import ApplicationRolesSection from "components/settings/permissions/application-roles/application-roles-section/application-roles-section";


export default function ApplicationRolesIndex() {

    return (
        <ApplicationRolesSection />
    );
}